export const buttonIcon = 'h-4 w-4 text-white mr-2';
export const labelContainer =
  'flex flex 1 flex-row justify-between items-center mb-6 pt-2';
export const stepsWrapper = 'px-4 pb-5 h-full';
